import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Overlay from '../../forms/_common/Overlay';
import FormErrors from '../../forms/_common/FormErrors';
import RequestError from '../../forms/_common/RequestError';
import ErrorMessage from '../../forms/_common/ErrorMessage';
import DialogTemplate from '../../dialogs_common/DialogTemplate';
import FormTemplate from '../../dialogs_common/FormTemplate';
import StringField from '../../forms/_fields_v2/StringField';
import FormField from '../../forms/_common/FormField';
import { EnvelopeIcon } from '@heroicons/react/24/outline';
import { OutlineButton, SolidButton } from '../../components/Button';
import validators from '../../utils/validators';
import { useQueryMutation } from '../../../hooks/@lore/query-connect';
import FormTemplateButtonFooter from '../../dialogs_common/FormTemplateButtonFooter';

Step1.propTypes = {
  data: PropTypes.object.isRequired,
  onNext: PropTypes.func.isRequired
};

export default function Step1(props) {
  const {
    data: _data,
    onNext,
    onCancel,
    emailChangeRequest
  } = props;

  const [data, setData] = useState({
    submittedCode: ''
  });
  const [showErrors, setShowErrors] = useState(false);

  const mutation = useQueryMutation('emailChangeRequest.update', emailChangeRequest);
  const { saving, success, error, request } = mutation;

  useEffect(() => {
    if (success) {
      onNext(request);
    }
  }, [success]);

  function onSubmit() {
    mutation.mutate({
      submittedCode: data.submittedCode
    });
  }

  function onChange(name, value) {
    setData(_.merge({}, data, {
      [name]: value
    }));
  }

  return (
    <DialogTemplate>
      <Overlay isVisible={saving}>
        <FormErrors data={data} validators={{
          submittedCode: [validators.isRequired]
        }}>
          {({ errors, hasError }) => {
            return (
              <FormTemplate
                icon={(
                  <div className="flex justify-center mb-4">
                    <EnvelopeIcon className="text-cs-orange-500 h-12 w-12" />
                  </div>
                )}
                title="We sent you a verification code."
                subtitle="Check your email and enter the code we sent you below."
                onClose={onCancel}
                alert={error ? (
                  <RequestError request={{
                    error: (
                      request.error.message === 'submittedCode' ? 'Invalid code. Try again.' :
                      request.error
                    )
                  }} />
                ) : showErrors ? (
                  <ErrorMessage>
                    Please fill in all required fields.
                  </ErrorMessage>
                ) : null}
                body={(
                  <FormField name="submittedCode" data={data} errors={showErrors && errors} onChange={onChange}>
                    {(field) => (
                      <StringField
                        // label="New Email"
                        placeholder="123456"
                        value={field.value}
                        error={field.error}
                        onChange={field.onChange}
                      />
                    )}
                  </FormField>
                )}
                footer={(
                  <FormTemplateButtonFooter>
                    <OutlineButton onClick={onCancel}>
                      Cancel
                    </OutlineButton>
                    <SolidButton onClick={() => hasError ? setShowErrors(true) : onSubmit()}>
                      Next
                    </SolidButton>
                  </FormTemplateButtonFooter>
                )}
              />
            );
          }}
        </FormErrors>
      </Overlay>
    </DialogTemplate>
  );
};
